import { render, staticRenderFns } from "./detailCollapse1.vue?vue&type=template&id=2d5c0e84&scoped=true&"
import script from "./detailCollapse1.vue?vue&type=script&lang=js&"
export * from "./detailCollapse1.vue?vue&type=script&lang=js&"
import style0 from "./detailCollapse1.vue?vue&type=style&index=0&id=2d5c0e84&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5c0e84",
  null
  
)

export default component.exports